import { CellAction } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const CellActionAsLinkExample = {
    title: 'CellAction - As link',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview(){
        return (
            <CellAction
                asChild
                before={<PlaceholderIcon />}
                mode="primary"
                showChevron
            >
                <a
                    href="/"
                    rel="noreferrer"
                    target="_blank"
                >
                    As link
                </a>
            </CellAction>
        )
    },

    getCode(){
        return `<CellAction
  asChild
  before={<Icon28Placeholder />}
  mode="primary"
  showChevron
>
  <a
    href="/"
    rel="noreferrer"
    target="_blank"
  >
    As link
  </a>
</CellAction>`
    }
}